// import { DragObjectWithType } from 'react-dnd';
import { Nilable } from 'tsdef';

import type { StartDragNDropPayload } from './action-payloads.types';
import { FileData } from './file.types';

export interface ChonkyDndDropResult {
  dropTarget: Nilable<FileData> | any;
  dropSource?: File[];
  dropEffect: 'move' | 'copy' | 'upload';
}

export type ChonkyDndFileEntryItem = {
  type: string;
  payload: StartDragNDropPayload;
};
export const ChonkyDndFileEntryType = 'dnd-chonky-file-entry';
